import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Link, Stack, Typography } from "@mui/material";

import NotFoundIcon from "./NotFoundIcon";

// `sx` adjusts the frame: admin fills the viewport below its top bar (GEN5-5269 P5).
const NotFound = ({ to = "/", title = "Go to Home Page", sx = {} }) => {
  const navigate = useNavigate();
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      gap={1}
      sx={{ height: "100%", width: "100%", ...sx }}
    >
      <NotFoundIcon />
      <Typography variant="h5" color="text.primary">
        Oops! Page not found!
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        You don't have permission to access this page, or it doesn't exist.
        <br />
        It could also be us. Contact us at{" "}
        <Link href="mailto:support@tsc.ai">support@tsc.ai</Link> if the problem
        persists.
      </Typography>
      <Button variant="contained" onClick={() => navigate(to)} sx={{ mt: 1 }}>
        {title}
      </Button>
    </Stack>
  );
};

export default NotFound;
